import { usePayoutMethodsQuery } from "queries";

const usePaymentMethodColumn = () => {
	const { data: payoutMethods, isFetching } = usePayoutMethodsQuery();

	return {
		name: "paymentMethod",
		type: "select" as const,
		loadOptions: () => ({
			options: payoutMethods,
			hasMore: false,
		}),
		loading: isFetching,
		getOptionLabel: option => option.displayName,
		getOptionValue: option => option.value,
		placeholder: "Payment Method",
	};
};

export default usePaymentMethodColumn;
